class ScenesController {
  constructor ($scope, $log, $timeout, ClientService, SceneService) {
    'ngInject'

    this._$log = $log
    this._$timeout = $timeout
    this._$scope = $scope
    this.copySuccess = false
    this.clientId = ClientService.id
    this.copyTimer = null
    this.Scenes = SceneService.getAll()

    this.unsubscribe = SceneService.subscribe(state => {
      this.Scenes = state.Scenes
    })

    $scope.$on('$destroy', this.unsubscribe)
  }

  copyToClipboard () {
    if (this.copyTimer) {
      this._$timeout.cancel(this.copyTimer)
      this.copyTimer = null
    }

    navigator.clipboard.writeText(this.clientId)
      .then(() => {
        this._$scope.$apply(() => {
          this.copySuccess = true
          this.copyTimer = this._$timeout(() => {
            this.copySuccess = false
            this.copyTimer = null
          }, 2000)
        })
      })
      .catch((err) => {
        this._$log.error('Unable to copy text!', err)
      })
  }
}

export default {
  controller: ScenesController,
  template: require('./scenes.component.html').default
}
